// extracted by mini-css-extract-plugin
module.exports = {"link":"Notification_link__2f6ra","description":"Notification_description__2XEVU"};